export default "__VITE_ASSET__3uqskyru__"